import React from 'react';
import PropTypes from 'prop-types';

import HorseDefinition from '../../../shared/HorseDefinition';

const DamSire = ({
    damSireHorseName,
    damSireUid,
    damSireCountryOriginCode,
    damSireAvgFlatWinDist,
}) => (
    <HorseDefinition
        avgFlatWinDist={damSireAvgFlatWinDist}
        countryOriginCode={damSireCountryOriginCode}
        horseName={damSireHorseName}
        horseUid={damSireUid}
        term="Dam's Sire"
    />
);

DamSire.propTypes = {
    damSireHorseName: PropTypes.string,
    damSireUid: PropTypes.number,
    damSireCountryOriginCode: PropTypes.string,
    damSireAvgFlatWinDist: PropTypes.number,
};

export default DamSire;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/DamSire.jsx